import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "template"]

    addAssociation(event) {
        event.preventDefault()
        const content = this.templateTarget.content.cloneNode(true)
        const timestamp = new Date().getTime()

        // Update field names with unique timestamp
        content.querySelectorAll('input, select, textarea').forEach(field => {
            if (field.name) {
                field.name = field.name.replace(/NEW_RECORD/g, timestamp)
            }
            if (field.id) {
                field.id = field.id.replace(/NEW_RECORD/g, timestamp)
            }
        })

        this.containerTarget.appendChild(content)
    }

    removeAssociation(event) {
        event.preventDefault()
        const row = event.target.closest('.nested-fields')

        if (!row) {
            console.error('Could not find .nested-fields element')
            return
        }

        const destroyField = row.querySelector('input[name*="_destroy"]')

        if (row.dataset.newRecord === 'true') {
            // Just remove new records
            row.remove()
        } else {
            // Mark existing records for destruction
            if (destroyField) {
                destroyField.value = '1'
            }
            row.style.display = 'none'
        }
    }

    markForDestruction(event) {
        event.preventDefault()
        const button = event.target.closest('button')
        const card = button.closest('.kit-panel')

        if (!card) {
            console.error('Could not find .kit-panel element')
            return
        }

        const destroyField = card.querySelector('input[name*="_destroy"]')

        if (!destroyField) {
            console.error('Could not find destroy field in card:', card)
            return
        }

        destroyField.value = '1'

        card.style.opacity = '0.5'
        card.style.pointerEvents = 'none'

        // Replace button with badge
        if (button) {
            button.outerHTML = '<span class="status-badge status-badge--danger" style="width:100%;justify-content:center;">Будет удалено</span>'
        }
    }
}
